export const ShowApplications = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1224_22628" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20">
      <path
        d="M17.25 10C19.0449 10 20.5 8.54493 20.5 6.75C20.5 4.95507 19.0449 3.5 17.25 3.5C15.4551 3.5 14 4.95507 14 6.75C14 8.54493 15.4551 10 17.25 10Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M17.25 20.5C19.0449 20.5 20.5 19.0449 20.5 17.25C20.5 15.4551 19.0449 14 17.25 14C15.4551 14 14 15.4551 14 17.25C14 19.0449 15.4551 20.5 17.25 20.5Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M6.75 10C8.54493 10 10 8.54493 10 6.75C10 4.95507 8.54493 3.5 6.75 3.5C4.95507 3.5 3.5 4.95507 3.5 6.75C3.5 8.54493 4.95507 10 6.75 10Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M6.75 20.5C8.54493 20.5 10 19.0449 10 17.25C10 15.4551 8.54493 14 6.75 14C4.95507 14 3.5 15.4551 3.5 17.25C3.5 19.0449 4.95507 20.5 6.75 20.5Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
    </mask>
    <g mask="url(#mask0_1224_22628)">
      <path d="M0 0H24V24H0V0Z" fill="#2469F3" />
    </g>
  </svg>
);
